import React from 'react'
import { twMerge } from 'tailwind-merge'

export const TwoColumnTinyTable = ({
  className,
  children,
}: {
  className?: string
  children: React.ReactNode
}) => {
  return (
    <table className={twMerge('my-2 table-auto font-medium', className)}>
      <tbody>{children}</tbody>
    </table>
  )
}
